<section class="new-contract-data-offer__container">
  <h2 class="new-contract-data-offer__title">
    {{ 'NEW_CONTRACT_LA.DATA_OFFER' | i18nextEager | uppercase }}
  </h2>
  <form [formGroup]="dataOfferForm" class="new-contract-data-offer__form">
    <div>
      <app-custom-select
        [label]="'NEW_CONTRACT_LA.SELECT_CAMPAIGN'"
        [controlName]="'campaign'"
        [values]="campaignList"
        [required]="true"
        [defaultValue]="dataOfferForm?.get('campaign')?.value"
      ></app-custom-select>
      <mat-error
        *ngIf="
          dataOfferForm.get('campaign').errors?.required &&
          (dataOfferForm.get('campaign').touched || dataOfferForm.get('campaign').dirty)
        "
      >
        {{ 'COMMONS.REQUIRED_FIELD' | i18nextEager }}
      </mat-error>
    </div>
    <div>
      <app-custom-select
        [label]="'NEW_CONTRACT_LA.SELECT_LEVEL'"
        [controlName]="'level'"
        [values]="levelList"
        [required]="true"
        [disabled]="dataOfferForm.get('level').disabled"
        [defaultValue]="dataOfferForm?.get('level')?.value"
      ></app-custom-select>
      <mat-error
        *ngIf="
          dataOfferForm.get('level').errors?.required &&
          (dataOfferForm.get('level').touched || dataOfferForm.get('level').dirty)
        "
      >
        {{ 'COMMONS.REQUIRED_FIELD' | i18nextEager }}
      </mat-error>
    </div>
    <div class="new-contract-data-offer__container-radio">
      <label>{{ 'NEW_CONTRACT_LA.RENOVATE' | i18nextEager }} *</label>
      <mat-radio-group aria-labelledby="" formControlName="renovate" ngDefaultControl>
        <mat-radio-button [value]="true">
          <span>{{ 'COMMONS.YES' | i18nextEager }}</span>
        </mat-radio-button>
        <mat-radio-button [value]="false">
          <span>{{ 'COMMONS.NO' | i18nextEager }}</span>
        </mat-radio-button>
      </mat-radio-group>
      <mat-error
        *ngIf="
          dataOfferForm.get('renovate').errors?.required &&
          (dataOfferForm.get('renovate').touched || dataOfferForm.get('renovate').dirty)
        "
      >
        {{ 'COMMONS.REQUIRED_FIELD' | i18nextEager }}
      </mat-error>
    </div>
    <div class="new-contract-data-offer__container-radio">
      <label>{{ 'NEW_CONTRACT_LA.ELECTRIC_TAX' | i18nextEager }} *</label>
      <mat-radio-group aria-labelledby="" formControlName="electric" ngDefaultControl>
        <mat-radio-button [value]="true">
          <span>{{ 'COMMONS.YES' | i18nextEager }}</span>
        </mat-radio-button>
        <mat-radio-button [value]="false">
          <span>{{ 'COMMONS.NO' | i18nextEager }}</span>
        </mat-radio-button>
      </mat-radio-group>
      <mat-error
        *ngIf="
          dataOfferForm.get('electric').errors?.required &&
          (dataOfferForm.get('electric').touched || dataOfferForm.get('electric').dirty)
        "
      >
        {{ 'COMMONS.REQUIRED_FIELD' | i18nextEager }}
      </mat-error>
    </div>
  </form>
</section>
<section class="new-contract-data-offer__container">
  <h2 class="new-contract-data-offer__title">
    {{ 'NEW_CONTRACT_LA.RISK_ASSASSMENT' | i18nextEager | uppercase }}
  </h2>
  <form [formGroup]="dataOfferForm" class="new-contract-data-offer__form">
    <mat-form-field appearance="outline">
      <mat-label>{{ 'NEW_CONTRACT_LA.OMIP' | i18nextEager }}</mat-label>
      <input matInput formControlName="omip" maxlength="6" decimal [disabled]="dataOfferForm.get('omip').disabled" />
      <mat-error
        *ngIf="
          (dataOfferForm.get('omip').errors?.required || !dataOfferForm.get('omip').errors?.valid) &&
          (dataOfferForm.get('omip').touched || dataOfferForm.get('omip').dirty)
        "
      >
        {{ 'NEW_CONTRACT_LA.NUMERIC_ERROR' | i18nextEager }}
      </mat-error>
    </mat-form-field>
    <div class="new-contract-data-offer__container-input">
      <span class="new-contract-data-offer__title-input"
        >{{ 'NEW_CONTRACT_LA.CREDIT_ANALYSIS' | i18nextEager | uppercase }} *</span
      >
      <div class="new-contract-data-offer__container-label">
        <ng-container *ngIf="approved && callQuery">
          <img src="/assets/icons/approved.svg" alt="{{ 'NEW_CONTRACT_LA.APPROVED' | i18nextEager }}" />
          <span class="new-contract-data-offer__label">{{ 'NEW_CONTRACT_LA.APPROVED' | i18nextEager }}</span>
        </ng-container>
        <ng-container *ngIf="!approved && callQuery">
          <img src="/assets/icons/rejected.svg" alt="{{ 'NEW_CONTRACT_LA.REJECTED' | i18nextEager }}" />
          <span class="new-contract-data-offer__label">{{ 'NEW_CONTRACT_LA.REJECTED' | i18nextEager }}</span>
        </ng-container>
        <button
          class="new-contract-data-offer__button"
          [disabled]="dataOfferForm.get('omip').invalid || dataOfferForm.get('omip').disabled"
          (click)="handleQuery()"
        >
          {{ 'NEW_CONTRACT_LA.QUERY' | i18nextEager }}
        </button>
      </div>
    </div>
  </form>
</section>
